import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../api.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {AichatComponent} from "../aichat/aichat.component";
import {MicCheckComponent} from "../mic-check/mic-check.component";
import {MatButton} from "@angular/material/button";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-activity',
  imports: [
    MatProgressSpinner,
    AichatComponent,
    MicCheckComponent,
    MatButton,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatIcon
  ],
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.css'
})
export class ActivityComponent implements OnInit {
  public actId: any;
  public activity: any;
  public loading: boolean = false;
  public butLoading: boolean = false;

  termsForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    borndate: new FormControl('', [Validators.required]),
    submit: new FormControl()
  });

  constructor(private route: ActivatedRoute, private api: ApiService, private router: Router, private snack: MatSnackBar) {
  }

  async ngOnInit() {
    this.loading = true;
    try {
      this.actId = this.route.snapshot.paramMap.get('id');
      this.activity = await this.api.getActivityDetail(this.actId);
      let check = {success: true};
      console.log()
      if (this.activity.state != 'complete')  {
        console.log('activity not yet completed');
        check = await this.api.setActivityState(this.actId, 'in_progress');
      }
      else {
        console.log('!!! ACCESSING ALREADY COMPLETED ACTIVITY !!!');
        if (this.activity.type != 2 && this.activity.type != 4 && this.activity.type != 5) {
          this.snack.open('Aktivita již byla dříve splněna', 'Zavřít', {duration: 3000});
          check.success = false;
          return this.goBack();
        }
      }
      if (!check.success) {
        this.router.navigate(['forbidden']);
      } else {
        this.loading = false;
        if (this.activity.type == 2 || this.activity.type == 4) {
          const link = this.activity.params.link.replace("{{id}}", this.api.userData.respondent_id);
          window.open(link, '_blank');
          if (this.activity.state != 'complete') await this.api.setActivityState(this.actId, 'complete');
          this.router.navigate(['dashboard']);
        }
        if (this.activity.type == 1) {
          this.termsForm.controls['name'].setValue(this.api.userData.name);
          this.termsForm.controls['address'].setValue(this.api.userData.address);
          this.termsForm.controls['borndate'].setValue(this.api.userData.borndate);
        }
      }
    }
    catch (e) {
      console.log(e);
      this.router.navigate(['error']);
    }
  }

  public async completeActivity() {
    if (this.termsForm.valid) {
      this.butLoading = true;
      await this.api.saveTermsData(this.termsForm.get('name')?.value,this.termsForm.get('address')?.value,this.termsForm.get('borndate')?.value);
      if (this.activity.state != 'complete') {
        console.log('setting activity as completed');
        await this.api.setActivityState(this.actId, 'complete');
      }
      this.snack.open('Aktivita úspěšně dokončena', 'Zavřít', {duration: 3000});
      this.goBack();
      this.butLoading = false;
    }
  }
  public goBack() {
    this.router.navigate(['dashboard']);
  }

}
